// extracted by mini-css-extract-plugin
module.exports = {"search-page-sort":"SearchPageSort_search-page-sort__aeon1"};